/* eslint-disable import/prefer-default-export */
import { createAction } from 'redux-actions';

// Action Declarations
// Suggested Action Name Standard: ORG_MODULE_ACTION_ANY
export const createPatientInformationAction = createAction('REFORAL_CREATE_PATIENT_INFORMATION');
export const updatePatientInformationAction = createAction('REFORAL_UPDATE_PATIENT_INFORMATION');
export const getReferralsAction = createAction('REFORAL_GET_REFERRALS');
export const showReferralAction = createAction('REFORAL_SHOW_REFERRAL');
// clinic super user request start
export const getClinicReferralsAction = createAction('REFORAL_GET_CLINIC_REFERRALS');
// Home's Ongoing table only: no reducer handles it, so it never touches the Referrals list.
export const getHomeOngoingReferralsAction = createAction('REFORAL_GET_HOME_ONGOING_REFERRALS');
export const showClinicReferralAction = createAction('REFORAL_SHOW_CLINIC_REFERRAL');
// clinic super user request end
export const createPatientHistoryAction = createAction('REFORAL_CREATE_PATIENT_HISTORY');
export const updatePatientHistoryAction = createAction('REFORAL_UPDATE_PATIENT_HISTORY');
export const getReferredByListAction = createAction('REFORAL_GET_REFERRED_BY_LIST');
export const getDentistListAction = createAction('REFORAL_GET_REFERRAL_DENTIST_LIST');
export const getClinicListAction = createAction('REFORAL_GET_REFERRAL_CLINIC_LIST');
export const saveReferralInfoAction = createAction('REFORAL_SAVE_REFERRAL_INFORMATION');
export const saveReferralReasonAction = createAction('REFORAL_SAVE_REFERRAL_REASON');
export const saveReferralAttachmentAction = createAction('REFORAL_SAVE_REFERRAL_ATTACHMENT');
export const sendReferralMessageAction = createAction('REFORAL_SEND_REFERRAL_MESSAGE');
export const getReferralMessagesAction = createAction('REFORAL_GET_REFERRAL_MESSAGES');
export const updateReferralStatusAction = createAction('REFORAL_UPDATE_REFERRAL_STATUS');
export const markReferralConversationReadAction = createAction('REFORAL_MARK_REFERRAL_CONVERSATION_READ');
export const markReferralConversationInListReadAction = createAction('REFORAL_MARK_REFERRAL_CONVERSATION_IN_LIST_READ');
export const markReferralConversationInListUnreadAction = createAction('REFORAL_MARK_REFERRAL_CONVERSATION_IN_LIST_UNREAD');
export const getUnreadReferralConversationAction = createAction('REFORAL_GET_UNREAD_REFERRAL_CONVERSATION');
export const updateReferralInfoAction = createAction('REFORAL_UPDATE_REFERRAL_INFORMATION');
export const updateReferralLabInfoAction = createAction('REFORAL_SAVE_REFERRAL_LABORATORY_INFO');

export const deleteReferralAction = createAction('REFORAL_DELETE_REFERRAL');
export const copyPatientRecordAction = createAction('REFORAL_COPY_PATIENT_RECORD');
export const deleteReferralMessageAttachmentAction = createAction('REFORAL_DELETE_REFERRAL_MESSAGE_ATTACHMENT');
export const deleteReferralAttachmentAction = createAction('REFORAL_DELETE_REFERRAL_ATTACHMENT');
export const getReferralMessageThreadAction = createAction('REFORAL_GET_REFERRAL_MESSAGE_THREAD');
export const getReferralMessageAttachmentsAction = createAction('REFEORAL_GET_REFERRAL_MESSAGE_ATTACHMENTS');
export const downloadReferralMessageAttachmentAction = createAction('REFORAL_DOWNLOAD_REFERRAL_MESSAGE_ATTACHMENT');
export const generateSummaryFileRequestAction = createAction('REFORAL_GENERATE_SUMMARY_FILE');

export const getLaboratoryListAction = createAction('REFORAL_GET_REFERRAL_LABORATORY_LIST');
export const getAffiliatedClinicsAction = createAction('REFORAL_GET_AFFILIATED_CLINICS');
export const saveReferralLabInfoAction = createAction('REFORAL_SAVE_REFERRAL_LABORATORY_INFO');
export const getLabOrderCaseTypesAction = createAction('REFORAL_REFERRAL_LAB_ORDER_CASE_TYPES');
export const getLabOrderMaterialTypesAction = createAction('REFORAL_REFERRAL_LAB_ORDER_MATERIAL_TYPES');
export const getLabOrderImpressionTypesAction = createAction('REFORAL_REFERRAL_LAB_ORDER_IMPRESSION_TYPES');
export const saveReferralLabOrderDetailsAction = createAction('REFORAL_REFERRAL_SAVE_LAB_ORDER_DETAILS');
export const saveReferralLabOrderAttachmentsAction = createAction('REFORAL_REFERRAL_SAVE_LAB_ORDER_ATTACHMENTS');
export const showLabOrderAction = createAction('REFORAL_SHOW_REFERRAL_LAB_ORDER');
export const deleteLabOrderAction = createAction('REFORAL_DELETE_REFERRAL_LAB_ORDER');

export const displayMessageAction = createAction('REFORAL_DISPLAY_MESSAGE_ACTION');
export const updateMessageAction = createAction('REFORAL_UPDATE_MESSAGE');
export const deleteMessageAction = createAction('REFORAL_DELETE_MESSAGE');
export const clearReferralDataAction = createAction('REFORAL_CLEAR_REFERRAL_DATA');
export const updateUnreadReferralMessageCountAction = createAction('REFORAL_UPDATE_REFERRAL_UNREAD_MESSAGE_COUNT');
export const referralMessageArrivedAction = createAction('REFORAL_REFERRAL_MESSAGE_ARRIVED');
export const updateReferralListAction = createAction('REFORAL_UPDATE_REFERRAL_LIST');
export const updateReferralMessageStatusAction = createAction('REFORAL_UPDATE_REFERRAL_MESSAGE_STATUS');
export const deleteReceiverMessageAction = createAction('REFORAL_DELETE_RECEIVER_MESSAGE');
export const markAsUrgentAction = createAction('REFORAL_MARK_AS_URGENT_REFERRAL');

export const getAffiliatedReferralsAction = createAction('REFORAL_GET_AFFILIATED_REFERRALS');

export const updateReferralFollowUpStatusAction = createAction('REFORAL_UPDATE_FOLLOW_UP_STATUS');

export const updateReferralFilterAction = createAction('REFORAL_REFERRAL_UPDATE_FILTER');
export const updateReferralReferredByAction = createAction('REFORAL_REFERRAL_UPDATE_REFERRED_BY');
export const updateReferralReferredToAction = createAction('REFORAL_REFERRAL_UPDATE_REFERRED_TO');
